<template>
  <div>
    <h5 class="info-text">Seleciona el tipo de incidencia</h5>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox v-model="model.design" icon="fas fa-check" title="Calidad"></icon-checkbox>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox v-model="model.code" icon="fas fa-cart-arrow-down" title="Cantidad"></icon-checkbox>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox v-model="model.develop" icon="fas fa-truck" title="Servicio"></icon-checkbox>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <md-field v-if="model.design || model.code">
          <label>Unidades Afectadas</label>
          <md-input v-model="model.quantity"></md-input>
        </md-field>
        <md-field>
          <label>Observaciones</label>
          <md-textarea v-model="model.observations"></md-textarea>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components";

export default {
  components: {
    IconCheckbox
  },
  data() {
    return {
      model: {
        design: false,
        code: true,
        develop: false,
        observations: null
      }
    };
  },
  methods: {
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    }
  }
};
</script>
<style>
</style>
